import React from "react";

const MerchantTagBadge = ({ color = "#555", label, placement = "top" }) => {
  if (!label) return null;
  return (
    <span
      data-merchant-tag-placement={placement}
      style={{
        alignSelf: "flex-start",
        backgroundColor: color,
        borderRadius: 3,
        color: "white",
        display: "inline-block",
        fontSize: 12,
        fontWeight: 700,
        lineHeight: "18px",
        maxWidth: "100%",
        overflow: "hidden",
        padding: "1px 6px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
      title={label}
    >
      {label}
    </span>
  );
};

export default MerchantTagBadge;
